export const PHONE_NUMBER_REGEX = /\(?(\d{3})\)?[- .]?(\d{3})[- .]?(\d{4})/g
